import styled from 'styled-components';

import { SummaryFieldValue } from '../shared/styled';

export const SummarySidebarContainer = styled.div`
  color: var(--color-grayscale-black);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const SummarySidebarHeading = styled.h3`
  width: 100%;
  font: var(--font-headings-heading-3);
  margin: 0;
  padding: var(--sizes-50) var(--sizes-60) 0;
`;

export const SummarySidebarSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  gap: 8px;
  padding: var(--sizes-40) var(--sizes-60);
  border-bottom: 1px solid var(--color-gray-20);
`;

export const AppliedFiltersWrapper = styled(SummaryFieldValue)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
`;
